import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const Copyright = () => {
  return (
			<div>
				<Header></Header>
				<br />
				<br />
				<br />
				<div class='row  mx-auto  p-5'>
					<div class='card  bg-gradient border-danger border-5' style={{ backgroundColor: '#003300' }}>
						<div class='card-body text-white'>
							<h1 class='card-title text-center'>COPYRIGHT</h1>
							<p class='card-text text-start'>
                <br/>
								© 2026 epavistemoro.fr – Tous droits réservés.
                <br/>Toute reproduction, représentation, modification, publication, transmission ou adaptation de
								tout ou partie du site est interdite sans autorisation écrite préalable.
                <br/>Toute exploitation non autorisée sera poursuivie conformément aux
								dispositions du Code de la propriété intellectuelle.
							</p>
						</div>
					</div>
				</div>
				<br />
				<br />
				<br />
				<br />
				<Footer></Footer>
			</div>
		);
};

export default Copyright;
